import { render, staticRenderFns } from "./ListaHoleriteParaLiberacao.vue?vue&type=template&id=ddd0658e"
import script from "./ListaHoleriteParaLiberacao.vue?vue&type=script&lang=js"
export * from "./ListaHoleriteParaLiberacao.vue?vue&type=script&lang=js"
import style0 from "./ListaHoleriteParaLiberacao.vue?vue&type=style&index=0&id=ddd0658e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports